<template>
  <div class="c-tab-overview">
    <div class="o-grid o-grid--gutter-large">
      <div class="o-grid__group">
        <div class="o-grid__item  o-grid__item--9">
          <div class="o-grid o-grid--gutter-large">
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--6">
                <div class="o-grid o-grid--gutter-normal">
                  <div class="o-grid__group">
                    <div class="o-grid__item o-grid__item--12">
                      <CallCenterAEDcontactInformation></CallCenterAEDcontactInformation>
                    </div>
                    <div class="o-grid__item o-grid__item--12">
                      <CallCenterAEDserviceProvider></CallCenterAEDserviceProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="o-grid__item o-grid__item--6">
                <div class="o-grid o-grid--gutter-normal">
                  <div class="o-grid__group">
                    <div class="o-grid__item o-grid__item--12">
                      <CallCenterAEDaedData></CallCenterAEDaedData>
                    </div>
                    <div class="o-grid__item o-grid__item--12">
                      <CallCenterAEDuserData></CallCenterAEDuserData>
                    </div>
                    <div
                      class="o-grid__item o-grid__item--12"
                      v-if="pendingFadder"
                    >
                      <CallCenterAEDpendingMove></CallCenterAEDpendingMove>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="o-grid__item  o-grid__item--3">
          <CallCenterAEDstatus></CallCenterAEDstatus>
        </div>
        <div class="o-grid__item  o-grid__item--12">
          <CallCenterAEDhistory></CallCenterAEDhistory>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CallCenterAEDstatus from "@/components/AED/aed-status.vue";
import CallCenterAEDaedData from "@/components/AED/aed-data.vue";
import CallCenterAEDcontactInformation from "@/components/AED/aed-contactInformation.vue";
import CallCenterAEDhistory from "@/components/AED/aed-history.vue";
import CallCenterAEDserviceProvider from "@/components/AED/aed-serviceProvider.vue";
import CallCenterAEDuserData from "@/components/AED/aed-userData.vue";
import CallCenterAEDpendingMove from "@/components/AED/aed-pendingMove.vue";

export default {
  name: "c-tab-overview",
  components: {
    CallCenterAEDstatus,
    CallCenterAEDaedData,
    CallCenterAEDcontactInformation,
    CallCenterAEDhistory,
    CallCenterAEDserviceProvider,
    CallCenterAEDuserData,
    CallCenterAEDpendingMove
  },
  computed: {
    ...mapGetters("aed", ["pendingFadder"])
  }
};
</script>
<style lang="scss">
.c-tab-overview {
}
</style>
